//
// Formats a number to a human-readable string of bytes or bits such as "100 MB"
//
function formatBytes(bytes, options) {
  options = Object.assign({
    unit: 'bytes',
    locale: undefined,
  }, options);
  const byteUnits = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const bitUnits = ['b', 'kbit', 'Mbit', 'Gbit', 'Tbit', 'Pbit', 'Ebit', 'Zbit', 'Ybit'];
  const units = options.unit === 'bytes' ? byteUnits : bitUnits;
  const isNegative = bytes < 0;
  bytes = Math.abs(bytes);
  if (bytes === 0)
    return '0 B';
  const i = Math.min(Math.floor(Math.log10(bytes) / 3), units.length - 1);
  const num = Number((bytes / Math.pow(1000, i)).toPrecision(3));
  const numString = num.toLocaleString(options.locale);
  const prefix = isNegative ? '-' : '';
  return `${prefix}${numString} ${units[i]}`;
}
function formatNumber(number, { maxLength = 6, magnitudeSuffixes = {
  3: 'k',
  6: 'M',
  9: 'B',
  12: 'T',
}, scientificHighThreshold = 12, scientificLowThreshold = -4, } = {}) {
  if (typeof number === 'undefined')
    return '0';
  const n = typeof number == 'string' ? parseFloat(number) : number;
  const magnitude = Math.floor(Math.log10(n)) + 1;
  if (magnitude <= -100)
    return '0';
  if (magnitude >= 100)
    return 'A lot';
  if (magnitude >= scientificHighThreshold) {
    return n.toExponential(maxLength - 2 - (Math.log10(magnitude) + 1));
  }
  if (magnitude <= scientificLowThreshold) {
    return n.toExponential(maxLength - 2 - (Math.log10(-magnitude) + 1));
  }
  if (magnitude + Math.floor((magnitude - 1) / 3) > maxLength) {
    const excess = magnitude - maxLength + Math.floor((maxLength - 2) / 3);
    const excess3 = Math.ceil(excess / 3) * 3;
    const m = Math.round(n / 10 ** excess);
    const m2 = m / 10 ** (excess3 - excess);
    const ms = m2.toLocaleString() + magnitudeSuffixes[excess3];
    // const diff = ms.length - options.maxLength
    return ms;
    // if (diff < 0) return ms
    // return (
    //   (
    //     Math.round(m / Math.pow(10, diff + 1)) / Math.pow(10, 2 - diff)
    //   ).toLocaleString() + options.magnitudeSuffixes[excess3 + 3]
    // )
    // TODO: this is a prototype, improve
  }
  return n.toLocaleString();
}

export { formatNumber as a, formatBytes as f };
